import React from 'react';
import { Skeleton } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { DriverCardEventType, useDriverCard } from './use-driver-card';
import { Calendar, Page } from '../../components.js';
import styled from 'styled-components';
import { TaskType } from 'types';
import { grey } from '@ant-design/colors';
import { DriverCardEventTile } from './driver-card-event-tile';
import { Formatting } from '../../utils';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	> div {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 24px;

		> h3 {
			margin: 16px 0 8px 0;
			font-size: 20px;
			text-align: center;
		}
	}
`;

const OrderEvent = styled.div`
	display: flex;
	width: 100%;
	padding: 12px;
	border-radius: 6px;
	background: ${({ color }) => color};
	color: white;
	margin-bottom: 4px;

	> div {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	h4 {
		font-size: 18px;
		margin: 0;
		margin-bottom: 4px;
		color: white;
	}

	h5 {
		font-size: 18px;
		font-weight: 400;
		margin: 0;
		color: white;
	}

	:hover {
		cursor: pointer;
	}
`;

export const DriverCard: React.FC = () => {
	const { id: idRaw } = useParams();
	const [searchParams, setSearchParams] = useSearchParams({
		offset: '0',
	});

	const id = parseInt(idRaw || '0', 10);
	const offset = parseInt(searchParams.get('offset') || '0', 10);

	const { driver, events, summary } = useDriverCard(id, offset);

	// const printRef = useRef<CardPrint>();
	// const handlePrint = useReactToPrint({
	// 	content: () => printRef.current,
	// });

	if (!driver || !events || !summary) {
		return (
			<Page title="">
				<Skeleton active />
			</Page>
		);
	}

	return (
		<>
			<Page title={`Pracownicy / ${driver.name} ${driver.surname}`} actions={[]}>
				<Calendar offset={offset} onChange={(f) => setSearchParams({ offset: f(offset) })}>
					<Wrapper>
						<div>
							<h3>Podstawienia</h3>
							{events
								.filter(
									(e) =>
										(e.type === DriverCardEventType.classicOrder || e.type === DriverCardEventType.looseOrder) &&
										e.task.type === TaskType.delivery
								)
								.map((e) => (
									<DriverCardEventTile key={e.key} event={e} />
								))}
						</div>
						<div>
							<h3>Odbiory</h3>
							{events
								.filter(
									(e) =>
										(e.type === DriverCardEventType.classicOrder || e.type === DriverCardEventType.looseOrder) &&
										e.task.type === TaskType.claiming
								)
								.map((e) => (
									<DriverCardEventTile key={e.key} event={e} />
								))}
						</div>
						<div>
							<h3>Wymiany</h3>
							{events
								.filter(
									(e) =>
										(e.type === DriverCardEventType.classicOrder || e.type === DriverCardEventType.looseOrder) &&
										e.task.type === TaskType.replacement
								)
								.map((e) => (
									<DriverCardEventTile key={e.key} event={e} />
								))}
						</div>
						<div>
							<h3>Wydatki</h3>
							{events
								.filter((e) => e.type === DriverCardEventType.expense)
								.map((e) => (
									<DriverCardEventTile key={e.key} event={e} />
								))}
						</div>
						<div>
							<h3>Wydania gotówki</h3>
							{events
								.filter((e) => e.type === DriverCardEventType.settlement)
								.map((e) => (
									<DriverCardEventTile key={e.key} event={e} />
								))}
						</div>
						<div>
							<h3>Podsumowanie</h3>
							<OrderEvent color={grey[5]}>
								<div>
									<h4>Pobrane od klientów: {Formatting.money(summary.advances + summary.payments)}</h4>
									<h4>Wydane: {Formatting.money(summary.spent + summary.settlements)}</h4>
								</div>
								<div>
									<span>Zaliczki: {Formatting.money(summary.advances)}</span>
									<span>Zapłaty: {Formatting.money(summary.payments)}</span>
									<span>Wydatki: {Formatting.money(summary.spent)}</span>
									<span>Pobrania gotówki: {Formatting.money(summary.settlements)}</span>
								</div>
							</OrderEvent>
						</div>
						<div>
							<h3>
								Balans: {Formatting.money(summary.advances + summary.payments - summary.spent - summary.settlements)}
							</h3>
						</div>
					</Wrapper>
				</Calendar>
			</Page>

			{/* <CardPrint
				ref={printRef}
				user={user}
				events={events}
				card={card}
				summary={{ advances, payments, expenses, settlements }}
				date={moment().add(offset, 'days')}
			/> */}

			{/* <CardsPrint className="print" ref={cardsPrintRef}>
				<h2>Wydruk kart kierowcy z dnia {Formatting.epochToDate(moment(), true)}</h2>
				{prints}
			</CardsPrint> */}
		</>
	);
};
